/* Mon Panier d'Armor : points CSE (réservés aux salariés d'une entreprise, retrait un jeudi sur deux)
   - Pour ajouter une entreprise : ajouter une ligne dans MPA_CSE (début du nom du point en minuscules,
     nom affiché, empreinte SHA-256 du code promo en MAJUSCULES).
   - MPA_CSE_SEMAINE_REF = lundi d'une semaine AVEC retrait CSE. */
window.MPA_CSE = [
  { start: 'aist 22', nom: "l'AIST 22", hash: '7d2eba06152f22e7c5648a700078d84614865d5ecde3e3217e4457c2e5c02281' },
  { start: 'pinceaux raphaël', nom: 'Pinceaux Raphaël', hash: '4af27866865b33b8162f6c2157a29f6a6f228d179277acd0255f8f1c00c5c6d1' }
];
window.MPA_CSE_SEMAINE_REF = [2026, 11, 2]; // semaine du jeudi 5 novembre 2026
window.mpaCseFor = function (title) {
  var t = String(title || '').toLowerCase().trim();
  for (var i = 0; i < window.MPA_CSE.length; i++) {
    if (t.indexOf(window.MPA_CSE[i].start) === 0) return window.MPA_CSE[i];
  }
  return null;
};
window.mpaCseOff = function (title) {
  if (!window.mpaCseFor(title)) return false;
  var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' })
    .format(new Date()).split('-').map(Number);
  var today = Date.UTC(p[0], p[1] - 1, p[2]);
  var dow = (new Date(today).getUTCDay() + 6) % 7; // 0 = lundi
  var lundi = today - dow * 86400000;
  var r = window.MPA_CSE_SEMAINE_REF;
  var semaines = Math.round((lundi - Date.UTC(r[0], r[1] - 1, r[2])) / 604800000);
  return Math.abs(semaines) % 2 === 1;
};

/* Mon Panier d'Armor : point de retrait dans le panier + attribut de commande + fermeture des créneaux */
(function () {
  if (window.mpaPickupLoaded) return;
  window.mpaPickupLoaded = true;

  /* ===== Réglages ===== */
  var OPEN_DAY = 1, OPEN_HOUR = 14;      // ouverture des commandes : lundi 8h
  var CUTOFF_HOUR = 24;                 // un créneau ferme à minuit, la veille au soir du retrait
  var ATTR = 'Point de retrait';
  var DAYS = { lundi: 1, mardi: 2, mercredi: 3, jeudi: 4, vendredi: 5, samedi: 6, dimanche: 7 };

  var lastHandle = null;
  var lastSynced = typeof window.mpaCartPoint === 'string' ? window.mpaCartPoint : '';

  function parisNow() {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
    var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
    var wd = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 }[o.weekday];
    return { day: wd, minutes: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10) };
  }

  function dayOf(title) {
    var m = String(title || '').toLowerCase().match(/lundi|mardi|mercredi|jeudi|vendredi|samedi|dimanche/);
    return m ? DAYS[m[0]] : null;
  }

  function weekOpen() {
    var n = parisNow();
    if (n.day === 7) return false;
    if (n.day === OPEN_DAY && n.minutes < OPEN_HOUR * 60) return false;
    return true;
  }

  function isOpen(title) {
    if (window.mpaCseOff && window.mpaCseOff(title)) return false;
    if (!weekOpen()) return false;
    var d = dayOf(title);
    if (!d) return true;
    var n = parisNow();
    var cutoffDay = d - 1;
    if (n.day < cutoffDay) return true;
    if (n.day === cutoffDay && n.minutes < CUTOFF_HOUR * 60) return true;
    return false;
  }

  function getHandle() {
    try { return localStorage.getItem('selected-store'); } catch (e) { return null; }
  }

  function selectorEl() { return document.querySelector('store-selector[data-main-selector]') || document; }

  function getPoint() {
    var h = getHandle();
    if (!h) return null;
    var item = selectorEl().querySelector('.store-selector-item[data-handle="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"]');
    if (!item) return null;
    return {
      handle: h,
      title: item.dataset.title || '',
      zone: item.dataset.zone || '',
      time: item.dataset.time || '',
      address: (item.dataset.address || '').replace(/\s+/g, ' ').trim()
    };
  }

  function pointLabel(p) {
    if (!p) return '';
    var town = p.title.split(' – ')[0];
    var when = p.time ? town + ' – ' + p.time : p.title;
    return [when, p.address].filter(Boolean).join(' · ');
  }

  function syncAttribute() {
    var p = getPoint();
    var value = pointLabel(p);
    if (value === lastSynced) return;
    lastSynced = value;
    var attrs = {};
    attrs[ATTR] = value;
    attrs['Horaire et lieu de retrait'] = '';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () { lastSynced = null; });
  }

  function openSelector() {
    var modal = document.getElementById('modal-store-selector');
    if (modal && typeof modal.show === 'function') {
      var sidebar = document.getElementById('site-cart-sidebar');
      if (sidebar && typeof sidebar.hide === 'function') { try { sidebar.hide(); } catch (e) {} }
      modal.show();
    }
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* Points fermés dans le sélecteur */
  /* Points ouverts en haut, points complets en bas (ordre d'origine conservé dans chaque groupe) */
  function sortSelector() {
    var parents = [];
    document.querySelectorAll('.store-selector-item[data-title]').forEach(function (it) {
      if (parents.indexOf(it.parentElement) === -1) parents.push(it.parentElement);
    });
    parents.forEach(function (parent) {
      var items = Array.prototype.filter.call(parent.children, function (c) { return c.matches('.store-selector-item[data-title]'); });
      items.forEach(function (it, i) { if (!it.hasAttribute('data-mpa-idx')) it.setAttribute('data-mpa-idx', i); });
      var ACT = 'store-selector-item--store--active';
      var spot = function (it) {
        var li = document.querySelector('interactive-map [data-latitude][data-id="' + it.dataset.handle + '"]');
        return li ? li.dataset.latitude + ',' + li.dataset.longitude : '';
      };
      var activeIt = items.filter(function (it) { return it.classList.contains(ACT); })[0];
      var activeSpot = activeIt ? spot(activeIt) : '';
      items.forEach(function (it) {
        var same = !!activeSpot && it !== activeIt && spot(it) === activeSpot;
        it.classList.toggle('mpa-same-spot', same);
      });
      var rank = function (it) { return it.classList.contains(ACT) ? 0 : (it.classList.contains('mpa-same-spot') ? 1 : 2); };
      var sorted = items.slice().sort(function (x, y) {
        var ax = rank(x), ay = rank(y);
        var cx = x.classList.contains('mpa-closed') ? 1 : 0, cy = y.classList.contains('mpa-closed') ? 1 : 0;
        return ax - ay || cx - cy || (+x.getAttribute('data-mpa-idx')) - (+y.getAttribute('data-mpa-idx'));
      });
      var same = sorted.every(function (it, i) { return it === items[i]; });
      if (same) return;
      var anchor = items[items.length - 1].nextSibling;
      sorted.forEach(function (it) { parent.insertBefore(it, anchor); });
      if (sorted[0] && sorted[0].classList.contains(ACT)) {
        for (var el = parent; el && el !== document.body; el = el.parentElement) {
          var ov = getComputedStyle(el).overflowY;
          if ((ov === 'auto' || ov === 'scroll') && el.scrollHeight > el.clientHeight) { el.scrollTo({ top: 0, behavior: 'smooth' }); break; }
        }
      }
    });
  }
  ['click', 'touchend', 'pointerup'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(sortSelector, 80); setTimeout(sortSelector, 400); }, true);
  });
  var mpaSortTimer;
  new MutationObserver(function (muts) {
    for (var k = 0; k < muts.length; k++) {
      var t = muts[k].target;
      if (t.classList && t.classList.contains('store-selector-item')) { clearTimeout(mpaSortTimer); mpaSortTimer = setTimeout(sortSelector, 60); return; }
    }
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });

  function markSelector() {
    var changed = false;
    document.querySelectorAll('.store-selector-item[data-title]').forEach(function (it) {
      var closed = !isOpen(it.dataset.title);
      if (closed === it.classList.contains('mpa-closed')) return;
      changed = true;
      it.classList.toggle('mpa-closed', closed);
      it.setAttribute('aria-disabled', closed ? 'true' : 'false');
      var title = it.querySelector('.store-selector-item__title');
      var tag = it.querySelector('.mpa-closed-tag');
      if (closed && title && !tag) title.insertAdjacentHTML('beforeend', ' <span class="mpa-closed-tag">' + (window.mpaCseOff && window.mpaCseOff(it.dataset.title) ? 'Pas de retrait cette semaine' : 'Complet cette semaine') + '</span>');
      if (!closed && tag) tag.remove();
      var cb = it.querySelector('input[type=checkbox]');
      if (cb) cb.disabled = closed;
    });
    if (changed) sortSelector();
  }

  /* Phrase d'explication sous le titre de la fenêtre de choix du point */
  function addModalIntro() {
    var modal = document.getElementById('modal-store-selector');
    if (!modal || modal.querySelector('.mpa-modal-intro')) return;
    var title = null;
    modal.querySelectorAll('h1,h2,h3,h4,.h1,.h2,.h3,[class*="title"],[class*="heading"]').forEach(function (el) {
      if (!title && /choisir le lieu de retrait/i.test(el.textContent) && el.children.length <= 1) title = el;
    });
    var headText = modal.querySelector('.modal-heading__text');
    if (headText) { headText.insertAdjacentHTML('beforeend', '<p class="mpa-modal-intro">Un nouveau panier vous attend chaque lundi&nbsp;! Pour le recevoir, commandez au plus tard la veille de votre retrait, avant minuit.</p>'); return; }
    if (!title) return;
    title.insertAdjacentHTML('afterend', '<p class="mpa-modal-intro">Un nouveau panier vous attend chaque lundi&nbsp;! Pour le recevoir, commandez au plus tard la veille de votre retrait, avant minuit.</p>');
  }

  /* Lien « Changer » à côté du message de retrait sur les fiches et cartes produits */
  function addChangeLinks() {
    document.querySelectorAll('pickup-availability-compact').forEach(function (w) {
      var alert = w.querySelector('.alert');
      if (!alert || w.querySelector('.mpa-change')) return;
      if (!/retrait/i.test(alert.textContent) || /s[ée]lectionner/i.test(alert.textContent)) return;
      alert.insertAdjacentHTML('beforeend', ' <button type="button" class="mpa-pickup__link mpa-change" data-mpa-open>Changer</button>');
    });
  }

  function render() {
    addModalIntro();
    addChangeLinks();
    markSelector();
    var p = getPoint();
    var open = weekOpen();
    document.querySelectorAll('.mpa-pickup').forEach(function (wrap) {
      var box = wrap.querySelector('.mpa-pickup__box');
      if (!box) return;
      var blocked = [];
      if (p) {
        wrap.querySelectorAll('.mpa-pickup__item').forEach(function (it) {
          var zones = (it.dataset.zones || '').split(',').filter(Boolean);
          if (zones.length && zones.indexOf(p.zone) === -1) blocked.push(it.dataset.title);
        });
      }
      var html, state;
      if (!open) {
        state = 'closed';
        html = '<p class="mpa-pickup__label">Complet cette semaine</p>' +
               '<p class="mpa-pickup__text">Les commandes de la semaine sont terminées. Le nouveau panier arrive lundi matin !</p>';
      } else if (!wrap.querySelector('.mpa-pickup__item')) {
        state = 'nobasket';
        html = '<p class="mpa-pickup__label">Il manque votre panier</p>' +
               '<p class="mpa-pickup__text">Les produits additionnels s\'ajoutent à un panier de la semaine. Ajoutez d\'abord votre panier pour pouvoir commander.</p>' +
               '<a href="/collections/nos-paniers" class="mpa-pickup__btn button button--small button--solid">Voir les paniers</a>';
      } else if (!p) {
        state = 'missing';
        html = '<p class="mpa-pickup__label">Point de retrait</p>' +
               '<p class="mpa-pickup__text">Choisissez où récupérer votre panier avant de commander.</p>' +
               '<button type="button" class="mpa-pickup__btn button button--small button--solid" data-mpa-open>Choisir mon point de retrait</button>';
      } else if (!isOpen(p.title)) {
        state = 'closed';
        html = '<p class="mpa-pickup__label">Point de retrait : <strong>' + esc(p.title) + '</strong></p>' +
               '<p class="mpa-pickup__text">Ce créneau est complet cette semaine. Choisissez un autre point.</p>' +
               '<button type="button" class="mpa-pickup__link" data-mpa-open>Changer de point</button>';
      } else if (blocked.length) {
        state = 'blocked';
        html = '<p class="mpa-pickup__label">Point de retrait : <strong>' + esc(p.title) + '</strong></p>' +
               '<p class="mpa-pickup__text">' + esc(blocked.join(', ')) + (blocked.length > 1 ? ' ne sont pas disponibles' : ' n\'est pas disponible') + ' à ce point. Changez de point ou retirez ce panier.</p>' +
               '<button type="button" class="mpa-pickup__link" data-mpa-open>Changer de point</button>';
      } else {
        state = 'ok';
        html = '<p class="mpa-pickup__label">Votre point de retrait</p>' +
               '<p class="mpa-pickup__text"><strong>' + esc(p.title) + '</strong>' + (p.time ? '<br>' + esc(p.time) : '') + (p.address ? '<br><span class="mpa-pickup__addr">' + esc(p.address) + '</span>' : '') + '</p>' +
               '<button type="button" class="mpa-pickup__link" data-mpa-open>Modifier</button>';
      }
      if (box.getAttribute('data-html') !== html) { box.innerHTML = html; box.setAttribute('data-html', html); }
      wrap.setAttribute('data-state', state);
    });
  }

  function isValid() {
    var wraps = document.querySelectorAll('.mpa-pickup');
    if (!wraps.length) return true;
    var ok = true;
    wraps.forEach(function (w) { if (w.getAttribute('data-state') !== 'ok') ok = false; }); if (window.mpaCseBlocked) ok = false;
    return ok;
  }

  document.addEventListener('click', function (e) {
    var closedItem = e.target.closest('.store-selector-item.mpa-closed');
    if (closedItem && !e.target.closest('.js-accordion-tab button, [aria-expanded]')) {
      e.preventDefault(); e.stopImmediatePropagation(); return;
    }
    var opener = e.target.closest('[data-mpa-open]');
    if (opener) { e.preventDefault(); openSelector(); return; }
    var checkout = e.target.closest('#CheckOut, [name="checkout"]');
    if (checkout) {
      render();
      if (!isValid()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var w = document.querySelector('.mpa-pickup[data-state]');
        if (w) { w.classList.remove('mpa-pickup--shake'); void w.offsetWidth; w.classList.add('mpa-pickup--shake'); }
        if (weekOpen() && (!getPoint() || !isOpen(getPoint().title))) openSelector();
      } else {
        syncAttribute();
      }
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.id === 'cart' && !isValid()) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  var css = document.createElement('style');
  css.textContent =
    '.mpa-pickup{margin:0 0 16px;padding:14px 16px;border-radius:var(--border-radius,8px);border:1px solid rgba(var(--color-text-rgb,66,38,97),.2);background:rgba(var(--color-text-rgb,66,38,97),.04)}' +
    '.mpa-pickup[data-state=missing],.mpa-pickup[data-state=blocked],.mpa-pickup[data-state=closed],.mpa-pickup[data-state=nobasket]{border-color:#e0245e;background:rgba(224,36,94,.06)}' +
    '.mpa-pickup p{margin:0 0 6px}.mpa-pickup__label{font-size:.85em;opacity:.8}' +
    '.mpa-pickup__addr{font-size:.85em;opacity:.8}' +
    '.mpa-pickup__link{background:none;border:0;padding:0;text-decoration:underline;cursor:pointer;color:inherit;font:inherit}' +
    '.mpa-pickup__btn{margin-top:4px}' +
    '.mpa-change{margin-left:6px;font-size:inherit;font-weight:600}' +
    '.store-selector-item.mpa-closed{opacity:.45}' +
    '.store-selector-item.mpa-closed .store-selector-item__input-container{pointer-events:none}' +
    '.mpa-closed-tag{display:inline-block;margin-left:6px;padding:1px 8px;border-radius:20px;font-size:.75em;font-weight:600;background:#e0245e;color:#fff;vertical-align:middle}' +
    '.store-selector-item.store-selector-item--store--active{background:#fff!important;border-radius:12px}' +
    '.store-selector-item.mpa-same-spot{background:rgba(255,255,255,.6)!important;border-radius:12px;box-shadow:inset 3px 0 0 #e32463}' +
    'interactive-map .map-tag-pin.scaled-store-icon{background:#e32463!important;color:#fff!important}' +
    '.mpa-modal-intro{margin:8px 0 4px;font-size:1rem;line-height:1.5;font-weight:700;color:#e32463}' +
    '.mpa-toast{position:fixed;left:50%;bottom:24px;transform:translate(-50%,20px);opacity:0;z-index:99999;background:#422661;color:#fff0c9;padding:12px 20px;border-radius:30px;font-size:15px;font-weight:600;box-shadow:0 6px 20px rgba(0,0,0,.2);transition:all .3s;max-width:calc(100% - 32px);text-align:center}' +
    '.mpa-toast--show{opacity:1;transform:translate(-50%,0)}' +
    '.mpa-property-help{margin:4px 0 10px;font-size:.95em;opacity:.85}.mpa-property-help p{margin:0}' +
    '.mpa-pickup--shake{animation:mpaShake .4s}' +
    '@keyframes mpaShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-6px)}75%{transform:translateX(6px)}}';
  document.head.appendChild(css);

  /* Ajout d'un produit additionnel depuis la popup : on reste sur la fiche du panier (pas de panier latéral) */
  var mpaQuick = null;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('modal-box button[name="add"], modal-box [data-js-product-add-to-cart]');
    if (!btn) return;
    var modal = btn.closest('modal-box');
    var titleEl = modal.querySelector('.product-text h1, .product-text h2, [class*="product__title"], h1, h2');
    var qtyEl = modal.querySelector('input[name="quantity"]');
    mpaQuick = { until: Date.now() + 8000, modal: modal, title: titleEl ? titleEl.textContent.trim() : '', qty: qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1 };
  }, true);

  function mpaToast(msg) {
    var t = document.createElement('div');
    t.className = 'mpa-toast';
    t.innerHTML = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('mpa-toast--show'); });
    setTimeout(function () { t.classList.remove('mpa-toast--show'); setTimeout(function () { t.remove(); }, 400); }, 3200);
  }

  function patchSidebar() {
    var sb = document.getElementById('site-cart-sidebar');
    if (!sb || sb.mpaPatched || typeof sb.show !== 'function') return;
    sb.mpaPatched = true;
    var originalShow = sb.show.bind(sb);
    sb.show = function () {
      if (mpaQuick && Date.now() < mpaQuick.until) {
        var q = mpaQuick; mpaQuick = null;
        try { if (q.modal && typeof q.modal.hide === 'function') q.modal.hide(); } catch (err) {}
        mpaToast('✓ Ajouté à votre panier : ' + q.qty + ' × ' + esc(q.title || 'produit'));
        return;
      }
      return originalShow.apply(null, arguments);
    };
  }

  function tick() {
    patchSidebar();
    var h = getHandle();
    if (h !== lastHandle) { lastHandle = h; syncAttribute(); }
    render();
  }

  new MutationObserver(function () {
    if (document.querySelector('.mpa-pickup:not([data-state])') || document.querySelector('.store-selector-item[data-title]:not(.mpa-checked)')) {
      document.querySelectorAll('.store-selector-item[data-title]').forEach(function (i) { i.classList.add('mpa-checked'); });
      render();
    }
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('storechanged', function () { setTimeout(tick, 50); }, true);
  setInterval(tick, 1000);
  tick();
})();

/* MPA weekend popup */
(function () {
  var path = location.pathname;
  if (!(path.indexOf('/products/') === 0 || path.indexOf('/collections/nos-paniers') === 0)) return;
  var p = {};
  new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false })
    .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
  var d = p.weekday, h = parseInt(p.hour, 10) % 24, m = parseInt(p.minute, 10);
  var show = (d === 'Sat' && (h > 0 || m >= 1)) || d === 'Sun' || (d === 'Mon' && h < 14);
  if (!show) return;
  try { if (sessionStorage.getItem('mpa-wk-popup')) return; } catch (e) {}
  var css = document.createElement('style');
  css.textContent = '.mpa-wk{position:fixed;inset:0;z-index:99999;background:rgba(30,15,45,.55);display:flex;align-items:center;justify-content:center;padding:20px}' +
    '.mpa-wk__box{position:relative;background:#422661;color:#fdf1cf;border-radius:22px;max-width:440px;width:100%;padding:34px 28px 28px;text-align:center;box-shadow:0 20px 50px rgba(0,0,0,.3)}' +
    '.mpa-wk__box h2{margin:0 0 12px;color:#36b536;font-size:1.7rem;line-height:1.15}.mpa-wk__box h2 span{color:#e32463}' +
    '.mpa-wk__box p{margin:0 0 22px;font-size:1.05rem;line-height:1.5;color:#fdf1cf}' +
    '.mpa-wk__btn{display:inline-block;background:#e32463;color:#fff!important;border-radius:999px;padding:13px 28px;font-weight:700;text-decoration:none}' +
    '.mpa-wk__later{display:block;margin:14px auto 0;background:none;border:0;color:#fdf1cf;text-decoration:underline;cursor:pointer;font-size:.95rem}' +
    '.mpa-wk__x{position:absolute;top:10px;right:14px;background:none;border:0;color:#fdf1cf;font-size:1.6rem;line-height:1;cursor:pointer}';
  document.head.appendChild(css);
  var el = document.createElement('div');
  el.className = 'mpa-wk';
  el.innerHTML = '<div class="mpa-wk__box" role="dialog" aria-modal="true" aria-label="Nouveau panier lundi">' +
    '<button class="mpa-wk__x" type="button" aria-label="Fermer">&times;</button>' +
    '<h2>Rendez-vous <span>lundi 14h&nbsp;!</span></h2>' +
    '<p>Les commandes de la semaine sont closes. Le prochain panier sera en ligne lundi à 14h.<br>En attendant, découvrez comment ça marche.</p>' +
    '<a class="mpa-wk__btn" href="/pages/concept">Découvrir le concept</a>' +
    '<button class="mpa-wk__later" type="button">Fermer</button></div>';
  var close = function () { el.remove(); try { sessionStorage.setItem('mpa-wk-popup', '1'); } catch (e) {} };
  el.addEventListener('click', function (e) { if (e.target === el || e.target.closest('.mpa-wk__x, .mpa-wk__later')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.isConnected) close(); });
  var add = function () { document.body.appendChild(el); };
  if (document.body) add(); else document.addEventListener('DOMContentLoaded', add);
})();

/* MPA ambassadeur */
(function () {
  var ATTR = 'Ambassadeur';
  var value = (window.mpaCartAmb || '').trim();
  var timer;
  var css = document.createElement('style');
  css.textContent = '.mpa-amb{margin-top:14px}.cart-detail--collapsible-true>.mpa-amb{margin:0;padding:16px 0;border-top:1px solid rgba(66,38,97,.15);border-bottom:1px solid rgba(66,38,97,.15)}.mpa-amb__check{display:flex;align-items:center;gap:10px;cursor:pointer;font-weight:600}' +
    '.mpa-amb__check input{width:18px;height:18px;accent-color:#e32463;margin:0}' +
    '.mpa-amb__field{margin-top:10px}.mpa-amb__field[hidden]{display:none}.mpa-amb__field label{display:block;margin-bottom:6px;font-size:.95em}' +
    '.mpa-amb__field input{width:100%}.mpa-amb__help{display:block;margin-top:6px;font-size:.85em;opacity:.8}';
  document.head.appendChild(css);
  function save(v) {
    value = v;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var a = {}; a[ATTR] = v;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) });
    }, 500);
    document.querySelectorAll('.mpa-amb').forEach(sync);
  }
  function sync(box) {
    var cb = box.querySelector('input[type=checkbox]'), inp = box.querySelector('input[type=text]'), fld = box.querySelector('.mpa-amb__field');
    if (document.activeElement !== inp && inp.value !== value) inp.value = value;
    if (value && !cb.checked) cb.checked = true;
    fld.hidden = !cb.checked;
  }
  function inject() {
    document.querySelectorAll('cart-note').forEach(function (note, i) {
      var ff = note.closest('details') || note.closest('.form-field') || note;
      if (ff.nextElementSibling && ff.nextElementSibling.classList.contains('mpa-amb')) return;
      var id = 'mpa-amb-' + i + '-' + Math.random().toString(36).slice(2, 7);
      var box = document.createElement('div');
      box.className = 'form-field mpa-amb';
      box.innerHTML = '<label class="mpa-amb__check"><input type="checkbox"> J\u2019ai un ambassadeur</label>' +
        '<div class="mpa-amb__field" hidden><label for="' + id + '">Nom de votre ambassadeur</label>' +
        '<input type="text" id="' + id + '" autocomplete="off" placeholder="Pr\u00e9nom et nom">' +
        '<small class="mpa-amb__help">La personne qui r\u00e9cup\u00e8re votre panier pour vous.</small></div>';
      ff.parentNode.insertBefore(box, ff.nextSibling);
      var cb = box.querySelector('input[type=checkbox]'), inp = box.querySelector('input[type=text]');
      cb.addEventListener('change', function () {
        box.querySelector('.mpa-amb__field').hidden = !cb.checked;
        if (!cb.checked) { inp.value = ''; save(''); } else { inp.focus(); }
      });
      inp.addEventListener('input', function () { save(inp.value.trim()); });
      sync(box);
    });
  }
  inject();
  setInterval(inject, 1000);
  document.addEventListener('DOMContentLoaded', inject);
})();
/* /MPA ambassadeur */

/* MPA producteurs */
(function(){
  if(!/\/pages\/nos-producteurs/.test(location.pathname)) return;
  function slug(t){return (t||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');}
  var css=document.createElement('style');
  css.textContent='.card.mpa-hl{box-shadow:0 0 0 4px #e32463!important}.mpa-hl-tag{display:inline-block;background:#e32463;color:#fff;font-weight:700;font-size:14px;line-height:1.2;padding:6px 14px;border-radius:999px;margin:6px 0 10px}';
  document.head.appendChild(css);
  function run(){
    var map={};
    [].slice.call(document.querySelectorAll('.shopify-section')).forEach(function(s){
      var h=s.querySelector('.rich-text__title'); if(!h) return;
      var id=slug(h.textContent); if(!id) return;
      map[id]={s:s,card:s.querySelector('.card')||s,h:h};
      if(!document.getElementById(id)){var a=document.createElement('span');a.id=id;s.insertBefore(a,s.firstChild);}
    });
    var q=new URLSearchParams(location.search);
    var p=(q.get('p')||'').split(',').map(slug).filter(Boolean);
    if(!p.length) return;
    var label=q.get('produit'), first=null;
    p.forEach(function(id){
      var m=map[id]; if(!m) return;
      m.card.classList.add('mpa-hl');
      if(label && !m.card.querySelector('.mpa-hl-tag')){var t=document.createElement('span');t.className='mpa-hl-tag';t.textContent=label;m.h.parentNode.insertBefore(t,m.h);}
      if(!first) first=m.s;
    });
    if(!first) return;
    var tops=p.map(function(id){return map[id]&&map[id].s;}).filter(Boolean);
    tops.sort(function(a,b){return a.getBoundingClientRect().top-b.getBoundingClientRect().top;});
    first=tops[0];
    try{history.scrollRestoration='manual';}catch(e){}
    function go(){
      var hd=document.querySelector('.site-header')||document.querySelector('header');
      var off=(hd?hd.getBoundingClientRect().height:0)+24;
      window.scrollTo(0, first.getBoundingClientRect().top+window.pageYOffset-off);
    }
    setTimeout(go,300);
    window.addEventListener('load',function(){setTimeout(go,200);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
})();
/* /MPA producteurs */

/* MPA rivo fr */
(function(){
  var rules=[[/^\s*Earn\s+(\d+)\s+Points?\s*$/i,'Dès $1 commandes'],[/^\s*Rewards\s*$/,'Récompenses'],[/^\s*Perks\s*$/,'Avantages']];
  function fix(root){
    if(!root||!root.ownerDocument) return;
    var w=root.ownerDocument.createTreeWalker(root,4), n;
    while((n=w.nextNode())){ var t=n.nodeValue; for(var i=0;i<rules.length;i++){ if(rules[i][0].test(t)){ n.nodeValue=t.replace(rules[i][0],rules[i][1]); break; } } }
  }
  function hook(){
    var f=document.getElementById('ba-other-window-body'); if(!f) return;
    var doc; try{doc=f.contentDocument;}catch(e){return;} if(!doc||!doc.body||doc.body.__mpaFr) return;
    doc.body.__mpaFr=true; fix(doc.body);
    new MutationObserver(function(){fix(doc.body);}).observe(doc.body,{childList:true,subtree:true,characterData:true});
  }
  setInterval(hook,1000);
})();
/* /MPA rivo fr */


/* Mon Panier d'Armor : points CSE – mention « Réservé » + code promo obligatoire dans le panier */
(function () {
  if (window.mpaCseLoaded) return;
  window.mpaCseLoaded = true;
  window.mpaCseBlocked = false;

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function currentTitle() {
    var h = null;
    try { h = localStorage.getItem('selected-store'); } catch (e) {}
    if (!h) return '';
    var sel = document.querySelector('store-selector[data-main-selector]') || document;
    var it = sel.querySelector('.store-selector-item[data-handle="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"]');
    return it ? (it.dataset.title || '') : '';
  }

  function sha256(s) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(s)).then(function (b) {
      return Array.prototype.map.call(new Uint8Array(b), function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    });
  }

  function tagPoints() {
    document.querySelectorAll('.store-selector-item[data-title]').forEach(function (it) {
      var c = window.mpaCseFor(it.dataset.title);
      if (!c || it.querySelector('.mpa-cse-tag')) return;
      var title = it.querySelector('.store-selector-item__title');
      var html = '<strong class="mpa-cse-tag">Point réservé aux CE</strong>';
      if (title) title.insertAdjacentHTML('afterend', html); else it.insertAdjacentHTML('afterbegin', html);
    });
    document.querySelectorAll('.mpa-pickup__text').forEach(function (p) {
      var s = p.querySelector('strong');
      var c = s && window.mpaCseFor(s.textContent);
      if (!c || p.querySelector('.mpa-cse-tag')) return;
      s.insertAdjacentHTML('afterend', '<br><strong class="mpa-cse-tag">Point réservé aux CE</strong>');
    });
  }

  function showMsg(c) {
    document.querySelectorAll('.mpa-pickup').forEach(function (w) {
      var m = w.querySelector('.mpa-cse-msg');
      if (!c) { if (m) m.remove(); return; }
      var txt = 'Point réservé aux CE. Ajoutez votre code CE dans « J\'ai un code » ci-dessous, ou choisissez un autre point de retrait.';
      if (!m) { m = document.createElement('p'); m.className = 'mpa-cse-msg'; w.appendChild(m); }
      if (m.textContent !== txt) m.textContent = txt;
    });
  }

  var checking = false, again = false;
  function check() {
    var c = window.mpaCseFor(currentTitle());
    document.documentElement.classList.toggle('mpa-cse-on', !!c);
    if (!c) { window.mpaCseBlocked = false; showMsg(null); return; }
    if (!document.querySelector('.mpa-pickup')) return; // pas de panier affiché : rien à vérifier
    if (checking) { again = true; return; }
    checking = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    window.mpaCseFetching = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || [])
          .filter(function (d) { return d.applicable !== false; })
          .map(function (d) { return String(d.code || '').trim().toUpperCase(); });
        return Promise.all(codes.map(sha256)).then(function (hs) {
          var ok = hs.indexOf(c.hash) !== -1;
          window.mpaCseBlocked = !ok;
          showMsg(ok ? null : c);
        });
      })
      .catch(function () {})
      .then(function () {
        window.mpaCseFetching = false;
        checking = false;
        if (again) { again = false; check(); }
      });
  }

  // Re-vérifie juste après chaque mise à jour du panier (ajout d'un code promo, changement de quantité…)
  if (window.fetch && !window.mpaCseFetchHooked) {
    window.mpaCseFetchHooked = true;
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var res = origFetch.apply(this, arguments);
      if (!window.mpaCseFetching && /\/(cart|discount)/.test(url)) {
        res.then(function () { setTimeout(check, 300); }, function () {});
      }
      return res;
    };
  }

  // Si le client clique sur « Commander » alors que le code n'est pas encore vérifié : on vérifie et on montre le message
  document.addEventListener('click', function (e) {
    if (e.target.closest('#CheckOut, [name="checkout"]') && window.mpaCseFor(currentTitle())) {
      tagPoints();
      check();
    }
  }, true);

  var css = document.createElement('style');
  css.textContent =
    '.mpa-cse-tag{display:block;font-weight:700;color:#e32463;font-size:13px;line-height:1.3;margin-top:2px}' +
    '.mpa-pickup__text .mpa-cse-tag{display:inline}' +
    '.mpa-cse-msg{color:#e32463;font-weight:600;font-size:14px;line-height:1.4;margin:8px 0 0}' +
    '.mpa-cse-on .additional-checkout-buttons,.mpa-cse-on shopify-accelerated-checkout-cart,.mpa-cse-on .shopify-payment-button,.mpa-cse-on [data-shopify="dynamic-checkout-cart"]{display:none!important}';
  document.head.appendChild(css);

  function tick() { tagPoints(); check(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
  setInterval(tick, 2000);
})();


/* Mon Panier d'Armor : cache le bouton Fidélité (Rivo) quand la fenêtre des points de retrait est ouverte, sinon il masque le bouton violet sur mobile */
(function () {
  var s = document.createElement('style');
  s.id = 'mpa-hide-fidelite';
  s.textContent = 'html:has(#modal-store-selector.active) #launcher-wrapper,html:has(#modal-store-selector.active) #loy-widget-wrapper{display:none!important}';
  document.head.appendChild(s);
})();
